import React, { FC, ReactNode } from "react";

interface Props {
    className?: string;
    children?: ReactNode;
}

const Card: FC<Props> = ({
    className = "",
    children,
}) => {
    return (
        <>
            <div className={`!z-5 relative flex flex-col rounded-2xl bg-white bg-clip-border shadow-xl dark:!bg-brand-700 dark:text-white dark:shadow-none ${className}`}>
                {children}
            </div>
        </>
    );
};

export default Card;